import { withOData } from "@odata/withOData";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

import Page, { IProps } from "../Page";
import { getDefinitions } from "./CustomerPortalPaymentDef";
import { CustomerPortalPaymentTableView } from "./CustomerPortalPaymentTableView";

class CustomerPortalPayment extends Page<IProps> {
    static defaultProps = {
        usePrompt: true,
        getDef: getDefinitions,
        tableView: CustomerPortalPaymentTableView
    };
}

export default withRouter(withTranslation(["Common", "Banks", "NumberRange", "Document", "CustomerPortalPayment"])(withOData(CustomerPortalPayment)));